import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-center px-4">
      <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-background-100 rounded-full">
        <i className="ri-ghost-line text-5xl text-foreground-300"></i>
      </div>
      <h1 className="text-6xl md:text-8xl font-heading font-black text-foreground-200 mb-4">404</h1>
      <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-3">页面未找到</h2>
      <p className="text-foreground-500 max-w-md mb-8">
        抱歉，你访问的页面已不存在或已被移动。让我们带你回到魔法世界吧！
      </p>
      <button
        onClick={() => navigate('/')}
        className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
      >
        <i className="ri-home-line"></i>
        返回首页
      </button>
    </div>
  );
}